import { render } from "./LeftFixd.vue?vue&type=template&id=801bb1ec&scoped=true"
const script = {}

import "./LeftFixd.vue?vue&type=style&index=0&id=801bb1ec&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801bb1ec"]])

export default __exports__